import { track_ga } from '@/pages/firebase'
import { globalVariable } from '@/utils/exportVariable'
import { loginQuickSuccessFB } from '@/utils/fbTtTrack'

function getPageName() {
  const { gameName } = globalVariable?.store?.state || {}
  return gameName
}

// 裂变活动弹窗
export const fission_popup = ({ from, page }) => {
  track_ga('fission_popup', {
    from,
    page: getPageName() ? getPageName() : page,
  })
}
// 快捷登录选择
export const login_quick = ({ login_way, button, from }) => {
  track_ga('login_quick', {
    login_way,
    button,
    from,
    page: getPageName() ? getPageName() : 'fission',
  })
}
// 注册成功
export const login_quick_success = ({ login_way, button, from, mode }) => {
  track_ga('login_quick_success', {
    login_way,
    button,
    from,
    mode,
    page: getPageName() ? getPageName() : 'fission',
  })
  loginQuickSuccessFB({ mode, login_way })
}
// 分享按钮曝光
export const fission_share = ({ reward = '', from = '' }) => {
  track_ga('fission_share', {
    reward,
    from,
    page: getPageName() ? getPageName() : 'fission',
  })
}
// 点击分享后，媒体选择按钮的曝光
export const share_show = ({ from }) => {
  track_ga('fission_share_show', {
    from,
    page: getPageName() ? getPageName() : 'fission',
  })
}
// 点击分享后，媒体选择按钮的点击
export const share_click = ({ from, share_name }) => {
  track_ga('fission_share_click', {
    from,
    share_name,
    page: getPageName() ? getPageName() : 'fission',
  })
}
// 分享链接被打开
export const share_success = ({ from, share_name }) => {
  track_ga('fission_share_success', {
    from,
    share_name,
    page: getPageName() ? getPageName() : 'fission',
  })
}
// 活动规则点击
export const fission_tip = ({ from }) => {
  track_ga('fission_tip', {
    from,
    page: getPageName() ? getPageName() : 'fission',
  })
}
// 去提取点击
export const fission_exchange = ({ from }) => {
  track_ga('fission_exchange', {
    from,
    page: getPageName() ? getPageName() : 'fission',
  })
}
// 兑换按钮点击（成功兑换）
export const fission_draw = ({ from, point }) => {
  track_ga('fission_draw', { from, point, page: 'fissoin' })
}
// 被分享弹窗曝光
export const fission_shared_popup = () => {
  track_ga('fission_shared_popup', {
    page: getPageName() ? getPageName() : 'fission',
  })
}
// 被分享弹窗去充值按钮点击
export const fission_shared_boost = () => {
  track_ga('fission_shared_boost', {
    page: getPageName() ? getPageName() : 'fission',
  })
}

// 降落伞点击
export const fission_parachute_click = () => {
  track_ga('parachute_click', {
    page: getPageName() ? getPageName() : 'fission',
  })
}
